import { useState, useEffect } from 'react';

type ViewMode = 'fit-to-width' | 'fit-to-height';

const STORAGE_KEY = 'bulletinLightboxViewMode';

export const useLightboxToggle = () => {
  const [viewMode, setViewMode] = useState<ViewMode>('fit-to-width');

  // Load saved preference on mount
  useEffect(() => {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved === 'fit-to-height' || saved === 'fit-to-width') {
      setViewMode(saved);
    }
  }, []);

  // Save to localStorage whenever mode changes
  const toggleViewMode = () => {
    const newMode: ViewMode = viewMode === 'fit-to-width' ? 'fit-to-height' : 'fit-to-width';
    setViewMode(newMode);
    localStorage.setItem(STORAGE_KEY, newMode);
  };

  return {
    viewMode,
    toggleViewMode,
    isFitToHeight: viewMode === 'fit-to-height'
  };
};